import React from 'react';
import {map} from 'lodash';

import styles from './spacing.module.scss';

/* Spacing guide
     name: spacing name
     spacing: value (in pixel units)
*/
export const SPACING = [
  {name: 'Tiny', value: 4},
  {name: 'X-Small', value: 8},
  {name: 'Small', value: 12},
  {name: 'Medium', value: 16},
  {name: 'Base', value: 24},
  {name: 'Large', value: 32},
  {name: 'X-Large', value: 40},
  {name: 'XX-Large', value: 64},
];

const Spacing = () => (
  <section className={styles.section}>
    <header>
      <h1 id="spacing">Spacing</h1>
    </header>

    <section className={styles.subsection}>
      <h2>Usage</h2>
      <p>Spacing between every design element should be a multiple of 4px.</p>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Spacing</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {map(SPACING, (space, i) => (
            <tr key={`spacing-${i}`}>
              <td>{`${space.value}px`}</td>
              <td>{space.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>

    <section className={styles.subsection}>
      <h2>Guides</h2>
      <p>Guides or “blocks” found in design files annotate spacing of elements.</p>
      <hr />
      <div className={styles.guides}>
        {map(SPACING, (space, i) => (
          <SpacingBox key={`spacing-box-${i}`} size={space.value} />
        ))}
      </div>
    </section>
  </section>
);

export default Spacing;

const SpacingBox = ({size}: {size: number}) => (
  <div className={styles.box} style={{height: size, width: size}}>
    <div className={styles.label} style={{fontSize: Math.min(14, size / 2)}}>
      {size}
    </div>
  </div>
);
